import React, { Component } from 'react'
import MUIDataTable from 'mui-datatables'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import config from 'config'

import { withStyles } from '@material-ui/core/styles'
import SearchIcon from '@material-ui/icons/Search'
import IconButton from '@material-ui/core/IconButton'
import Avatar from '@material-ui/core/Avatar'

import { userActions } from '../../_actions'
import owl from '../../images/owl-2.png'
import { checkValue } from '../../_helpers'

const styles = theme => ({
  button: {
    minWidth: 700
  }
})

class DataTableContainer extends Component {
  handleClick = (event, n) => {
    if (event === 'detail') {
      this.setState({
        selectedUser: n
      })

      this.props.dispatch(userActions.getById(n))
      this.props.handleOpenDetailModal()
    }
  }

  render() {
    const { users } = this.props

    const columns = [
      {
        name: 'Detail',
        options: {
          download: false,
          filter: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <IconButton
                color="secondary"
                aria-label="Edit"
                className={styles.button}
                onClick={event =>
                  this.handleClick('detail', tableMeta.rowData[2])
                }>
                <SearchIcon />
              </IconButton>
            )
          }
        }
      },
      {
        name: 'Avatar',
        options: {
          download: false,
          filter: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            let userId = tableMeta.rowData ? tableMeta.rowData[2] : ''
            let avatarUrl = tableMeta.rowData ? tableMeta.rowData[1] : ''
            return (
              <Avatar
                style={{ height: '30px', width: '30px' }}
                alt={userId}
                src={
                  checkValue(avatarUrl)
                    ? `${config.AvatarS3BucketEndpoint}/` + avatarUrl + '.png'
                    : owl
                }
                imgProps={{
                  onError: e => {
                    e.target.src = owl
                  }
                }}
              />
            )
          }
        }
      },
      {
        name: 'User Id',
        options: {
          filter: true,
          sort: true,
          sortDirection: 'asc',
          filterType: 'textField'
        }
      },
      {
        name: 'User Name',
        options: {
          filter: true,
          filterType: 'textField'
        }
      },
      'Job Title',
      'Team',
      {
        name: 'Email',
        options: {
          filter: true,
          filterType: 'textField'
        }
      },
      {
        name: 'Tag',
        options: {
          download: false,
          filter: true,
          filterOptions: getUserTag(users.items),
          filterType: 'multiselect',
          customBodyRender: (value, tableMeta, updateValue) => {
            return value
              ? value.map((item, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        border: '1px solid #ed3b57',
                        width: 'fit-content',
                        borderRadius: '10px',
                        fontSize: '1em',
                        color: '#ed3b57',
                        padding: '0 10px',
                        marginRight: '2px'
                      }}>
                      # {item}
                    </div>
                  )
                })
              : ''
          }
        }
      }
    ]

    let data =
      users.items &&
      users.items
        .filter(function(item) {
          return item.UserStatus !== 'D'
        })
        .map(item => {
          return [
            '',
            item.AvatarUrl,
            item.UserId,
            item.UserName,
            item.JobTitle,
            item.DepartmentName,
            item.Email,
            item.Tag
              ? item.Tag.map(item => {
                  return item.value
                })
              : ''
          ]
        })

    const options = {
      filter: true,
      selectableRows: false,
      filterType: 'dropdown',
      responsive: 'stacked',
      rowsPerPage: 10
    }

    return (
      <MUIDataTable
        title={'CloudRiches'}
        data={data}
        columns={columns}
        options={options}
      />
    )
  }
}

function getUserTag(data) {
  let tagArray = []

  data &&
    data.forEach(item => {
      item.Tag &&
        item.Tag.forEach(tagItem => {
          tagArray.push(tagItem.value)
        })
    })

  return tagArray
}

function mapStateToProps(state) {
  const { user } = state.authentication
  const { users } = state

  return {
    user,
    users
  }
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles)
)(DataTableContainer)



// WEBPACK FOOTER //
// ./src/components/Profile/DataTableContainer.js